package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Mayotte Flag (20x15dp)
 *
 * - ISO Alpha-2: YT
 * - ISO Alpha-3: MYT
 * - ISO Numeric: 175
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.Mayotte: ImageVector by lazy {
    ImageVector.Builder(
        name = "Mayotte:YT:MYT:175:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(fill = SolidColor(Color(0xFFDFDFDF))) {
                moveTo(6.931f, 13.268f)
                curveTo(6.515f, 13.394f, 5.916f, 13.652f, 5.676f, 13.796f)
                curveTo(5.598f, 13.847f, 5.605f, 13.903f, 5.725f, 14.117f)
                curveTo(5.81f, 14.255f, 5.895f, 14.375f, 5.909f, 14.375f)
                curveTo(5.93f, 14.375f, 6.163f, 14.281f, 6.424f, 14.161f)
                curveTo(6.685f, 14.048f, 7.018f, 13.899f, 7.171f, 13.872f)
                curveTo(7.288f, 13.851f, 7.396f, 13.832f, 7.462f, 13.807f)
                curveTo(7.488f, 13.865f, 7.472f, 13.833f, 7.521f, 13.924f)
                curveTo(7.59f, 14.054f, 7.547f, 14.051f, 7.668f, 14.087f)
                curveTo(7.795f, 14.125f, 8.109f, 13.972f, 8.109f, 13.972f)
                curveTo(8.476f, 13.859f, 8.681f, 13.847f, 10f, 13.847f)
                curveTo(11.319f, 13.847f, 11.524f, 13.859f, 11.89f, 13.979f)
                curveTo(11.89f, 13.979f, 12.186f, 14.068f, 12.223f, 14.079f)
                curveTo(12.261f, 14.09f, 12.281f, 14.098f, 12.321f, 14.09f)
                curveTo(12.357f, 14.082f, 12.395f, 14.033f, 12.412f, 14.003f)
                curveTo(12.412f, 14.003f, 12.493f, 13.829f, 12.514f, 13.768f)
                curveTo(12.584f, 13.798f, 12.712f, 13.837f, 12.835f, 13.872f)
                curveTo(12.984f, 13.916f, 13.315f, 14.048f, 13.576f, 14.161f)
                curveTo(13.837f, 14.281f, 14.07f, 14.375f, 14.091f, 14.375f)
                curveTo(14.105f, 14.375f, 14.19f, 14.255f, 14.274f, 14.117f)
                curveTo(14.444f, 13.821f, 14.458f, 13.847f, 13.844f, 13.564f)
                curveTo(13.026f, 13.186f, 12.208f, 13.017f, 12.13f, 13.199f)
                curveTo(12.116f, 13.233f, 12.104f, 13.254f, 12.085f, 13.299f)
                curveTo(12.003f, 13.282f, 11.788f, 13.237f, 11.573f, 13.205f)
                curveTo(10.91f, 13.098f, 9.09f, 13.098f, 8.427f, 13.205f)
                curveTo(8.212f, 13.237f, 8.066f, 13.289f, 7.945f, 13.319f)
                curveTo(7.876f, 13.196f, 7.89f, 13.245f, 7.876f, 13.211f)
                curveTo(7.82f, 13.085f, 7.446f, 13.105f, 6.931f, 13.268f)
                horizontalLineTo(6.931f)
                close()
            }
            path(fill = SolidColor(Color(0xFF171796))) {
                moveTo(7.531f, 5.496f)
                curveTo(7.517f, 5.701f, 7.559f, 5.846f, 7.671f, 5.956f)
                curveTo(7.72f, 6.008f, 7.763f, 6.07f, 7.763f, 6.07f)
                curveTo(7.763f, 6.07f, 7.706f, 6.133f, 7.659f, 6.18f)
                curveTo(7.547f, 6.29f, 7.502f, 6.433f, 7.502f, 6.583f)
                curveTo(7.502f, 6.738f, 7.547f, 6.845f, 7.668f, 6.985f)
                curveTo(7.668f, 6.985f, 7.77f, 7.037f, 7.768f, 7.1f)
                curveTo(7.765f, 7.164f, 7.659f, 7.228f, 7.659f, 7.228f)
                curveTo(7.441f, 7.483f, 7.448f, 7.775f, 7.675f, 8.018f)
                lineTo(7.773f, 8.125f)
                horizontalLineTo(10.004f)
                horizontalLineTo(12.233f)
                lineTo(12.342f, 8.003f)
                curveTo(12.552f, 7.765f, 12.552f, 7.508f, 12.344f, 7.235f)
                curveTo(12.344f, 7.235f, 12.239f, 7.16f, 12.237f, 7.098f)
                curveTo(12.236f, 7.035f, 12.337f, 6.973f, 12.337f, 6.973f)
                curveTo(12.555f, 6.698f, 12.55f, 6.445f, 12.325f, 6.18f)
                curveTo(12.223f, 6.063f, 12.221f, 6.04f, 12.301f, 5.986f)
                curveTo(12.432f, 5.893f, 12.512f, 5.581f, 12.453f, 5.391f)
                curveTo(12.365f, 5.106f, 11.989f, 4.916f, 11.759f, 5.041f)
                curveTo(11.716f, 5.063f, 11.631f, 5.126f, 11.567f, 5.178f)
                curveTo(11.503f, 5.233f, 11.444f, 5.276f, 11.432f, 5.276f)
                curveTo(11.423f, 5.276f, 11.366f, 5.231f, 11.307f, 5.176f)
                curveTo(11.077f, 4.968f, 10.8f, 4.943f, 10.57f, 5.178f)
                curveTo(10.57f, 5.178f, 10.538f, 5.304f, 10.489f, 5.308f)
                curveTo(10.441f, 5.312f, 10.373f, 5.196f, 10.373f, 5.196f)
                curveTo(10.139f, 4.963f, 9.845f, 4.973f, 9.606f, 5.218f)
                curveTo(9.606f, 5.218f, 9.572f, 5.321f, 9.518f, 5.308f)
                curveTo(9.464f, 5.296f, 9.42f, 5.176f, 9.42f, 5.176f)
                curveTo(9.28f, 5.041f, 9.191f, 5.043f, 9.03f, 5.041f)
                curveTo(8.938f, 5.039f, 8.77f, 5.062f, 8.668f, 5.138f)
                curveTo(8.567f, 5.213f, 8.585f, 5.304f, 8.561f, 5.298f)
                curveTo(8.503f, 5.283f, 8.438f, 5.188f, 8.438f, 5.188f)
                curveTo(8.211f, 4.983f, 8.028f, 4.948f, 7.808f, 5.071f)
                curveTo(7.635f, 5.166f, 7.545f, 5.306f, 7.531f, 5.496f)
                close()
            }
            path(fill = SolidColor(Color(0xFFD42E12))) {
                moveTo(7.678f, 9.057f)
                curveTo(7.678f, 9.057f, 7.769f, 9.102f, 7.766f, 9.158f)
                curveTo(7.763f, 9.215f, 7.666f, 9.271f, 7.666f, 9.271f)
                curveTo(7.612f, 9.333f, 7.552f, 9.422f, 7.534f, 9.466f)
                curveTo(7.458f, 9.655f, 7.515f, 9.909f, 7.664f, 10.054f)
                curveTo(7.754f, 10.145f, 7.756f, 10.182f, 7.671f, 10.29f)
                curveTo(7.633f, 10.337f, 7.588f, 10.403f, 7.571f, 10.438f)
                curveTo(7.394f, 10.787f, 7.659f, 11.225f, 8.052f, 11.225f)
                curveTo(8.209f, 11.225f, 8.327f, 11.173f, 8.434f, 11.055f)
                curveTo(8.519f, 10.962f, 8.564f, 10.959f, 8.64f, 11.043f)
                curveTo(8.751f, 11.171f, 8.898f, 11.25f, 9.021f, 11.25f)
                curveTo(9.166f, 11.25f, 9.256f, 11.203f, 9.403f, 11.058f)
                curveTo(9.403f, 11.058f, 9.461f, 10.944f, 9.514f, 10.944f)
                curveTo(9.567f, 10.945f, 9.616f, 11.06f, 9.616f, 11.06f)
                curveTo(9.837f, 11.306f, 10.059f, 11.314f, 10.355f, 11.08f)
                curveTo(10.355f, 11.08f, 10.42f, 10.985f, 10.476f, 10.986f)
                curveTo(10.532f, 10.988f, 10.58f, 11.085f, 10.58f, 11.085f)
                curveTo(10.711f, 11.203f, 10.808f, 11.25f, 10.936f, 11.25f)
                curveTo(11.064f, 11.25f, 11.159f, 11.198f, 11.308f, 11.045f)
                curveTo(11.308f, 11.045f, 11.385f, 10.93f, 11.431f, 10.922f)
                curveTo(11.477f, 10.915f, 11.526f, 11.011f, 11.526f, 11.011f)
                curveTo(11.708f, 11.181f, 11.808f, 11.235f, 11.941f, 11.235f)
                curveTo(12.078f, 11.235f, 12.175f, 11.188f, 12.313f, 11.06f)
                curveTo(12.441f, 10.94f, 12.509f, 10.799f, 12.493f, 10.684f)
                curveTo(12.476f, 10.558f, 12.367f, 10.329f, 12.286f, 10.251f)
                curveTo(12.286f, 10.251f, 12.206f, 10.244f, 12.218f, 10.182f)
                curveTo(12.23f, 10.12f, 12.324f, 10.056f, 12.324f, 10.056f)
                curveTo(12.557f, 9.773f, 12.559f, 9.554f, 12.329f, 9.274f)
                curveTo(12.329f, 9.274f, 12.233f, 9.219f, 12.234f, 9.156f)
                curveTo(12.236f, 9.093f, 12.334f, 9.03f, 12.334f, 9.03f)
                curveTo(12.557f, 8.757f, 12.554f, 8.504f, 12.329f, 8.255f)
                lineTo(12.208f, 8.125f)
                lineTo(9.991f, 8.127f)
                lineTo(7.773f, 8.13f)
                lineTo(7.673f, 8.246f)
                curveTo(7.441f, 8.514f, 7.443f, 8.787f, 7.678f, 9.057f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE9D315)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(11.138f, 8.514f)
                curveTo(11.245f, 8.514f, 11.335f, 8.587f, 11.353f, 8.683f)
                lineTo(11.357f, 8.72f)
                verticalLineTo(9.105f)
                lineTo(11.816f, 8.86f)
                curveTo(11.918f, 8.806f, 12.045f, 8.844f, 12.099f, 8.945f)
                curveTo(12.148f, 9.034f, 12.123f, 9.143f, 12.046f, 9.204f)
                lineTo(12.014f, 9.225f)
                lineTo(11.629f, 9.429f)
                lineTo(12.014f, 9.634f)
                lineTo(12.046f, 9.654f)
                curveTo(12.123f, 9.715f, 12.148f, 9.824f, 12.099f, 9.914f)
                curveTo(12.045f, 10.014f, 11.918f, 10.052f, 11.816f, 9.998f)
                lineTo(11.357f, 9.754f)
                verticalLineTo(10.182f)
                curveTo(11.357f, 10.296f, 11.259f, 10.389f, 11.138f, 10.389f)
                curveTo(11.031f, 10.389f, 10.941f, 10.315f, 10.923f, 10.219f)
                lineTo(10.919f, 10.182f)
                verticalLineTo(9.806f)
                lineTo(10.558f, 9.998f)
                curveTo(10.456f, 10.052f, 10.329f, 10.014f, 10.274f, 9.914f)
                curveTo(10.226f, 9.824f, 10.251f, 9.715f, 10.328f, 9.654f)
                lineTo(10.36f, 9.634f)
                lineTo(10.745f, 9.429f)
                lineTo(10.36f, 9.225f)
                lineTo(10.328f, 9.204f)
                curveTo(10.251f, 9.143f, 10.226f, 9.034f, 10.274f, 8.945f)
                curveTo(10.329f, 8.844f, 10.456f, 8.806f, 10.558f, 8.86f)
                lineTo(10.919f, 9.052f)
                verticalLineTo(8.72f)
                curveTo(10.919f, 8.606f, 11.017f, 8.514f, 11.138f, 8.514f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE9D315)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.013f, 8.514f)
                curveTo(9.121f, 8.514f, 9.21f, 8.587f, 9.229f, 8.683f)
                lineTo(9.232f, 8.72f)
                verticalLineTo(9.105f)
                lineTo(9.692f, 8.86f)
                curveTo(9.794f, 8.806f, 9.92f, 8.844f, 9.975f, 8.945f)
                curveTo(10.024f, 9.034f, 9.999f, 9.143f, 9.921f, 9.204f)
                lineTo(9.89f, 9.225f)
                lineTo(9.504f, 9.429f)
                lineTo(9.89f, 9.634f)
                lineTo(9.921f, 9.654f)
                curveTo(9.999f, 9.715f, 10.024f, 9.824f, 9.975f, 9.914f)
                curveTo(9.92f, 10.014f, 9.794f, 10.052f, 9.692f, 9.998f)
                lineTo(9.232f, 9.754f)
                verticalLineTo(10.182f)
                curveTo(9.232f, 10.296f, 9.134f, 10.389f, 9.013f, 10.389f)
                curveTo(8.906f, 10.389f, 8.817f, 10.315f, 8.798f, 10.219f)
                lineTo(8.795f, 10.182f)
                verticalLineTo(9.806f)
                lineTo(8.433f, 9.998f)
                curveTo(8.331f, 10.052f, 8.205f, 10.014f, 8.15f, 9.914f)
                curveTo(8.101f, 9.824f, 8.126f, 9.715f, 8.204f, 9.654f)
                lineTo(8.235f, 9.634f)
                lineTo(8.621f, 9.429f)
                lineTo(8.235f, 9.225f)
                lineTo(8.204f, 9.204f)
                curveTo(8.126f, 9.143f, 8.101f, 9.034f, 8.15f, 8.945f)
                curveTo(8.205f, 8.844f, 8.331f, 8.806f, 8.433f, 8.86f)
                lineTo(8.795f, 9.052f)
                verticalLineTo(8.72f)
                curveTo(8.795f, 8.606f, 8.893f, 8.514f, 9.013f, 8.514f)
                close()
            }
            path(
                stroke = SolidColor(Color.Black),
                strokeLineWidth = 0.4f
            ) {
                moveTo(6.677f, 4.375f)
                verticalLineTo(8.035f)
                horizontalLineTo(6.877f)
                verticalLineTo(8.035f)
                curveTo(6.877f, 8.036f, 6.877f, 8.067f, 6.877f, 8.124f)
                curveTo(6.763f, 8.121f, 6.679f, 8.037f, 6.677f, 8.035f)
                lineTo(6.677f, 8.035f)
                lineTo(6.677f, 8.036f)
                lineTo(6.677f, 8.036f)
                lineTo(6.677f, 8.037f)
                lineTo(6.677f, 8.043f)
                lineTo(6.677f, 8.065f)
                lineTo(6.677f, 8.151f)
                lineTo(6.677f, 8.463f)
                lineTo(6.678f, 9.463f)
                curveTo(6.679f, 10.221f, 6.68f, 11.077f, 6.682f, 11.469f)
                curveTo(6.678f, 11.573f, 6.708f, 11.659f, 6.772f, 11.731f)
                curveTo(6.799f, 11.76f, 6.828f, 11.784f, 6.85f, 11.8f)
                curveTo(6.862f, 11.81f, 6.871f, 11.817f, 6.879f, 11.823f)
                curveTo(6.89f, 11.831f, 6.9f, 11.838f, 6.914f, 11.849f)
                lineTo(7.038f, 11.693f)
                lineTo(6.914f, 11.849f)
                curveTo(6.989f, 11.909f, 7.105f, 11.948f, 7.216f, 11.977f)
                curveTo(7.337f, 12.008f, 7.488f, 12.035f, 7.659f, 12.056f)
                curveTo(7.999f, 12.096f, 8.43f, 12.111f, 8.887f, 12.075f)
                curveTo(9.062f, 12.078f, 9.185f, 12.111f, 9.275f, 12.155f)
                curveTo(9.367f, 12.2f, 9.436f, 12.259f, 9.497f, 12.325f)
                curveTo(9.529f, 12.359f, 9.557f, 12.394f, 9.587f, 12.431f)
                lineTo(9.59f, 12.434f)
                curveTo(9.617f, 12.468f, 9.649f, 12.507f, 9.682f, 12.542f)
                curveTo(9.751f, 12.613f, 9.856f, 12.7f, 10.012f, 12.7f)
                curveTo(10.168f, 12.7f, 10.273f, 12.612f, 10.34f, 12.539f)
                curveTo(10.373f, 12.503f, 10.405f, 12.462f, 10.432f, 12.427f)
                lineTo(10.432f, 12.426f)
                lineTo(10.434f, 12.425f)
                curveTo(10.462f, 12.388f, 10.488f, 12.355f, 10.517f, 12.321f)
                curveTo(10.575f, 12.255f, 10.639f, 12.197f, 10.724f, 12.154f)
                curveTo(10.809f, 12.111f, 10.926f, 12.077f, 11.096f, 12.075f)
                curveTo(11.609f, 12.083f, 12.049f, 12.071f, 12.381f, 12.039f)
                curveTo(12.547f, 12.024f, 12.691f, 12.003f, 12.806f, 11.976f)
                curveTo(12.909f, 11.953f, 13.023f, 11.917f, 13.101f, 11.852f)
                lineTo(13.105f, 11.849f)
                curveTo(13.109f, 11.845f, 13.115f, 11.84f, 13.122f, 11.834f)
                curveTo(13.135f, 11.822f, 13.153f, 11.806f, 13.173f, 11.785f)
                curveTo(13.207f, 11.75f, 13.267f, 11.683f, 13.296f, 11.598f)
                curveTo(13.32f, 11.528f, 13.326f, 11.465f, 13.327f, 11.418f)
                curveTo(13.327f, 11.395f, 13.325f, 11.375f, 13.324f, 11.36f)
                curveTo(13.324f, 11.358f, 13.323f, 11.356f, 13.323f, 11.354f)
                verticalLineTo(8.035f)
                verticalLineTo(4.375f)
                verticalLineTo(4.175f)
                horizontalLineTo(13.123f)
                horizontalLineTo(10f)
                horizontalLineTo(6.877f)
                horizontalLineTo(6.677f)
                verticalLineTo(4.375f)
                close()
            }
            path(fill = SolidColor(Color.White)) {
                moveTo(9.293f, 6.166f)
                curveTo(9.125f, 6.478f, 9.118f, 6.619f, 9.258f, 6.869f)
                curveTo(9.366f, 7.061f, 9.494f, 7.183f, 9.669f, 7.261f)
                curveTo(10.125f, 7.468f, 10.708f, 7.315f, 10.938f, 6.931f)
                curveTo(11.079f, 6.695f, 11.063f, 6.3f, 10.907f, 6.128f)
                lineTo(10.864f, 6.082f)
                lineTo(10.824f, 6.218f)
                curveTo(10.767f, 6.412f, 10.711f, 6.51f, 10.597f, 6.615f)
                curveTo(10.385f, 6.809f, 10.092f, 6.853f, 9.789f, 6.733f)
                curveTo(9.555f, 6.639f, 9.461f, 6.508f, 9.373f, 6.146f)
                lineTo(9.352f, 6.056f)
                lineTo(9.293f, 6.166f)
                lineTo(9.293f, 6.166f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFF2500)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(11.131f, 2f)
                curveTo(11.131f, 2.577f, 10.774f, 3f, 10.273f, 3f)
                curveTo(9.772f, 3f, 9.419f, 2.577f, 9.419f, 2f)
                curveTo(9.419f, 1.42f, 9.772f, 1f, 10.273f, 1f)
                curveTo(10.774f, 1f, 11.131f, 1.42f, 11.131f, 2f)
                close()
                moveTo(4.299f, 2.968f)
                verticalLineTo(1.621f)
                lineTo(4.809f, 2.968f)
                horizontalLineTo(5.032f)
                lineTo(5.531f, 1.621f)
                verticalLineTo(2.968f)
                horizontalLineTo(5.832f)
                verticalLineTo(1.032f)
                horizontalLineTo(5.482f)
                lineTo(4.924f, 2.52f)
                lineTo(4.359f, 1.032f)
                horizontalLineTo(4f)
                verticalLineTo(2.968f)
                horizontalLineTo(4.299f)
                close()
                moveTo(6.415f, 2.968f)
                lineTo(6.605f, 2.432f)
                horizontalLineTo(7.315f)
                lineTo(7.505f, 2.968f)
                horizontalLineTo(7.825f)
                lineTo(7.112f, 1.032f)
                horizontalLineTo(6.811f)
                lineTo(6.098f, 2.968f)
                horizontalLineTo(6.415f)
                close()
                moveTo(6.705f, 2.148f)
                horizontalLineTo(7.212f)
                lineTo(6.958f, 1.432f)
                lineTo(6.705f, 2.148f)
                close()
                moveTo(8.715f, 2.968f)
                verticalLineTo(2.196f)
                lineTo(9.389f, 1.032f)
                horizontalLineTo(9.057f)
                lineTo(8.568f, 1.899f)
                lineTo(8.075f, 1.032f)
                horizontalLineTo(7.734f)
                lineTo(8.405f, 2.196f)
                verticalLineTo(2.968f)
                horizontalLineTo(8.715f)
                close()
                moveTo(10.273f, 2.707f)
                curveTo(9.947f, 2.707f, 9.736f, 2.41f, 9.736f, 2f)
                curveTo(9.736f, 1.59f, 9.947f, 1.293f, 10.273f, 1.293f)
                curveTo(10.599f, 1.293f, 10.814f, 1.59f, 10.814f, 2f)
                curveTo(10.814f, 2.41f, 10.599f, 2.707f, 10.273f, 2.707f)
                close()
                moveTo(12.151f, 1.322f)
                verticalLineTo(2.968f)
                horizontalLineTo(11.837f)
                verticalLineTo(1.322f)
                horizontalLineTo(11.221f)
                verticalLineTo(1.032f)
                horizontalLineTo(12.767f)
                verticalLineTo(1.322f)
                horizontalLineTo(12.151f)
                close()
                moveTo(13.878f, 2.968f)
                verticalLineTo(1.322f)
                horizontalLineTo(14.494f)
                verticalLineTo(1.032f)
                horizontalLineTo(12.948f)
                verticalLineTo(1.322f)
                horizontalLineTo(13.564f)
                verticalLineTo(2.968f)
                horizontalLineTo(13.878f)
                close()
                moveTo(16f, 2.675f)
                verticalLineTo(2.968f)
                horizontalLineTo(14.789f)
                verticalLineTo(1.032f)
                horizontalLineTo(16f)
                verticalLineTo(1.322f)
                horizontalLineTo(15.097f)
                verticalLineTo(1.833f)
                horizontalLineTo(15.915f)
                verticalLineTo(2.12f)
                horizontalLineTo(15.097f)
                verticalLineTo(2.675f)
                horizontalLineTo(16f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFDFDFDF)),
                stroke = SolidColor(Color.Black),
                strokeLineWidth = 0.3f,
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(16.11f, 11.75f)
                curveTo(16.11f, 11.75f, 15.898f, 11.332f, 16.435f, 11.125f)
                curveTo(16.973f, 10.918f, 17.235f, 11.188f, 17.472f, 11.438f)
                curveTo(17.709f, 11.688f, 17.683f, 12.443f, 17.683f, 12.443f)
                lineTo(17.098f, 13.379f)
                lineTo(15.303f, 13.75f)
                lineTo(14.588f, 13.379f)
                lineTo(13.75f, 11.75f)
                lineTo(13.813f, 10.151f)
                curveTo(13.813f, 10.151f, 13.897f, 9.538f, 13.897f, 9.412f)
                curveTo(13.897f, 9.285f, 14.287f, 8.302f, 14.287f, 8.302f)
                lineTo(14.656f, 7.937f)
                lineTo(15.699f, 7.382f)
                lineTo(16.19f, 7.136f)
                lineTo(16.8f, 6.365f)
                lineTo(16.732f, 5.752f)
                lineTo(16.037f, 6.637f)
                horizontalLineTo(15.449f)
                lineTo(14.836f, 6.894f)
                lineTo(14.588f, 7.127f)
                lineTo(14.287f, 7.136f)
                lineTo(14.169f, 6.894f)
                lineTo(14.498f, 6.365f)
                lineTo(14.995f, 5.865f)
                lineTo(14.766f, 5.442f)
                lineTo(15.105f, 5.288f)
                lineTo(15.04f, 5.054f)
                lineTo(15.415f, 5.288f)
                lineTo(15.699f, 5.054f)
                lineTo(15.753f, 4.84f)
                lineTo(15.105f, 4.492f)
                curveTo(15.105f, 4.492f, 15.739f, 4.226f, 16.037f, 4.254f)
                curveTo(16.336f, 4.282f, 16.617f, 4.633f, 16.617f, 4.633f)
                lineTo(17.472f, 4.492f)
                curveTo(17.472f, 4.492f, 17.243f, 5.054f, 17.317f, 5.054f)
                curveTo(17.391f, 5.054f, 17.855f, 5.054f, 17.855f, 5.054f)
                lineTo(17.683f, 5.752f)
                horizontalLineTo(18.345f)
                lineTo(17.855f, 6.289f)
                lineTo(18.237f, 6.498f)
                lineTo(17.656f, 6.894f)
                lineTo(18.237f, 7.285f)
                lineTo(17.697f, 7.64f)
                lineTo(18.001f, 8.228f)
                lineTo(18.48f, 7.937f)
                lineTo(18.75f, 8.302f)
                lineTo(18.345f, 9.202f)
                lineTo(17.683f, 9.671f)
                lineTo(17.052f, 9.83f)
                lineTo(16.435f, 9.99f)
                lineTo(16.19f, 10.151f)
                lineTo(16.037f, 9.535f)
                lineTo(14.995f, 10.25f)
                lineTo(14.453f, 11.371f)
                lineTo(14.613f, 12.39f)
                lineTo(14.995f, 12.911f)
                lineTo(15.699f, 13.163f)
                lineTo(16.617f, 12.991f)
                lineTo(17.098f, 12.406f)
                lineTo(17.212f, 11.809f)
                curveTo(17.212f, 11.809f, 16.934f, 11.405f, 16.732f, 11.438f)
                curveTo(16.531f, 11.472f, 16.11f, 11.75f, 16.11f, 11.75f)
                close()
            }
            path(
                stroke = SolidColor(Color.Black),
                strokeLineWidth = 0.2f
            ) {
                moveTo(15.054f, 7.762f)
                curveTo(15.054f, 7.762f, 16.166f, 7.865f, 16.463f, 7.629f)
            }
            path(
                stroke = SolidColor(Color.Black),
                strokeLineWidth = 0.2f
            ) {
                moveTo(14.218f, 8.483f)
                curveTo(14.218f, 8.483f, 15.329f, 8.587f, 15.626f, 8.351f)
            }
            path(
                stroke = SolidColor(Color.Black),
                strokeLineWidth = 0.2f
            ) {
                moveTo(14.031f, 9.146f)
                curveTo(14.031f, 9.146f, 14.631f, 9.246f, 14.69f, 9.038f)
            }
            path(
                fill = SolidColor(Color.Black),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(15.469f, 5.938f)
                curveTo(15.382f, 5.938f, 15.313f, 5.868f, 15.313f, 5.781f)
                curveTo(15.313f, 5.695f, 15.382f, 5.625f, 15.469f, 5.625f)
                curveTo(15.555f, 5.625f, 15.625f, 5.695f, 15.625f, 5.781f)
                curveTo(15.625f, 5.868f, 15.555f, 5.938f, 15.469f, 5.938f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFDFDFDF)),
                stroke = SolidColor(Color.Black),
                strokeLineWidth = 0.3f,
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.89f, 11.75f)
                curveTo(3.89f, 11.75f, 4.102f, 11.332f, 3.565f, 11.125f)
                curveTo(3.027f, 10.918f, 2.765f, 11.188f, 2.528f, 11.438f)
                curveTo(2.291f, 11.688f, 2.317f, 12.443f, 2.317f, 12.443f)
                lineTo(2.902f, 13.379f)
                lineTo(4.697f, 13.75f)
                lineTo(5.412f, 13.379f)
                lineTo(6.25f, 11.75f)
                lineTo(6.187f, 10.151f)
                curveTo(6.187f, 10.151f, 6.103f, 9.538f, 6.103f, 9.412f)
                curveTo(6.103f, 9.285f, 5.713f, 8.302f, 5.713f, 8.302f)
                lineTo(5.344f, 7.937f)
                lineTo(4.301f, 7.382f)
                lineTo(3.81f, 7.136f)
                lineTo(3.2f, 6.365f)
                lineTo(3.268f, 5.752f)
                lineTo(3.963f, 6.637f)
                horizontalLineTo(4.551f)
                lineTo(5.164f, 6.894f)
                lineTo(5.412f, 7.127f)
                lineTo(5.713f, 7.136f)
                lineTo(5.831f, 6.894f)
                lineTo(5.502f, 6.365f)
                lineTo(5.005f, 5.865f)
                lineTo(5.234f, 5.442f)
                lineTo(4.895f, 5.288f)
                lineTo(4.96f, 5.054f)
                lineTo(4.585f, 5.288f)
                lineTo(4.301f, 5.054f)
                lineTo(4.247f, 4.84f)
                lineTo(4.895f, 4.492f)
                curveTo(4.895f, 4.492f, 4.261f, 4.226f, 3.963f, 4.254f)
                curveTo(3.664f, 4.282f, 3.383f, 4.633f, 3.383f, 4.633f)
                lineTo(2.528f, 4.492f)
                curveTo(2.528f, 4.492f, 2.757f, 5.054f, 2.683f, 5.054f)
                curveTo(2.609f, 5.054f, 2.145f, 5.054f, 2.145f, 5.054f)
                lineTo(2.317f, 5.752f)
                horizontalLineTo(1.655f)
                lineTo(2.145f, 6.289f)
                lineTo(1.763f, 6.498f)
                lineTo(2.344f, 6.894f)
                lineTo(1.763f, 7.285f)
                lineTo(2.303f, 7.64f)
                lineTo(1.999f, 8.228f)
                lineTo(1.519f, 7.937f)
                lineTo(1.25f, 8.302f)
                lineTo(1.655f, 9.202f)
                lineTo(2.317f, 9.671f)
                lineTo(2.948f, 9.83f)
                lineTo(3.565f, 9.99f)
                lineTo(3.81f, 10.151f)
                lineTo(3.963f, 9.535f)
                lineTo(5.005f, 10.25f)
                lineTo(5.547f, 11.371f)
                lineTo(5.387f, 12.39f)
                lineTo(5.005f, 12.911f)
                lineTo(4.301f, 13.163f)
                lineTo(3.383f, 12.991f)
                lineTo(2.902f, 12.406f)
                lineTo(2.787f, 11.809f)
                curveTo(2.787f, 11.809f, 3.066f, 11.405f, 3.268f, 11.438f)
                curveTo(3.47f, 11.472f, 3.89f, 11.75f, 3.89f, 11.75f)
                close()
            }
            path(
                stroke = SolidColor(Color.Black),
                strokeLineWidth = 0.2f
            ) {
                moveTo(4.946f, 7.762f)
                curveTo(4.946f, 7.762f, 3.834f, 7.865f, 3.537f, 7.629f)
            }
            path(
                stroke = SolidColor(Color.Black),
                strokeLineWidth = 0.2f
            ) {
                moveTo(5.782f, 8.483f)
                curveTo(5.782f, 8.483f, 4.671f, 8.587f, 4.374f, 8.351f)
            }
            path(
                stroke = SolidColor(Color.Black),
                strokeLineWidth = 0.2f
            ) {
                moveTo(5.969f, 9.146f)
                curveTo(5.969f, 9.146f, 5.369f, 9.246f, 5.31f, 9.038f)
            }
            path(
                fill = SolidColor(Color.Black),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.531f, 5.938f)
                curveTo(4.618f, 5.938f, 4.688f, 5.868f, 4.688f, 5.781f)
                curveTo(4.688f, 5.695f, 4.618f, 5.625f, 4.531f, 5.625f)
                curveTo(4.445f, 5.625f, 4.375f, 5.695f, 4.375f, 5.781f)
                curveTo(4.375f, 5.868f, 4.445f, 5.938f, 4.531f, 5.938f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun MayottePreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.Mayotte,
            contentDescription = "Mayotte Flag"
        )
    }
}
